module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/blog-rich-825b817a3211ecc10b21a3cdd2707998.jpg";